import React from 'react';
import StickySearchBar from './StickySearchBar';

interface TableListSkeletonProps {
    showSearchBar?: boolean;
}
const TableListSkeleton: React.FC<TableListSkeletonProps> = ({ showSearchBar = true }) => {
  return (
    <div className="bg-gray-50 min-h-screen animate-pulse">
      {/* Search Bar Skeleton */}
      {showSearchBar && <div className="sticky top-0 z-20 bg-white border-b border-gray-200">
        <StickySearchBar
          onSearch={() => {}}
          showShadow={true}
          searchFields={[ { id: 'all', label: 'ทั้งหมด', placeholder: 'ทั้งหมด' } ]}
          onSearchFieldChange={() => {} }        />
      </div>}
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header Skeleton */}
        <div className="pt-4 sm:pt-6 pb-0 sm:pb-4 sm:pb-1 flex justify-between items-center">
          <div className="h-8 w-32 bg-gray-200 rounded"></div>
          <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
        </div>

        {/* Filter Skeleton */}
        <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 justify-between pb-4">
          <div className="flex flex-row items-center justify-start gap-2">
            <div className="h-8 w-24 bg-gray-200 rounded"></div>
            <div className="h-8 w-24 bg-gray-200 rounded"></div>
            <div className="h-8 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Table Skeleton */}
        <div className="overflow-x-auto bg-white rounded-lg shadow-md p-4">
          <div className="space-y-4">
            {/* Table Header */}
            <div className="flex gap-4">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="h-8 bg-gray-200 flex-1 rounded"></div>
              ))}
            </div>
            
            {/* Table Rows */}
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex gap-4">
                {[...Array(5)].map((_, j) => (
                  <div key={j} className="h-12 bg-gray-100 flex-1 rounded"></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListSkeleton;
